(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afsaana-main-landing"] && !Shopify.designMode) return;
  try {
    
  if (!window.AfsaanaLandingReady) {
    window.AfsaanaLandingReady = true;

    function updateAfsaanaGallery(gallery) {
      var track = gallery && gallery.querySelector('[data-afs-media-track]');
      if (!track || !track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      gallery.querySelectorAll('[data-afs-media-dot]').forEach(function (dot) {
        dot.classList.toggle('is-active', Number(dot.dataset.afsMediaDot) === index);
      });
    }

    document.addEventListener('click', function (event) {
      var quickFocus = event.target.closest('[data-afs-quick-focus]');
      if (quickFocus) {
        var quickCard = quickFocus.closest('.afs__product-card');
        var quickTarget = quickCard && quickCard.querySelector('.afs__quick-add-form select, .afs__quick-add-form button[type="submit"]');
        if (quickTarget) {
          quickTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { quickTarget.focus({ preventScroll: true }); }, 350);
        }
        return;
      }

      var mediaControl = event.target.closest('[data-afs-media-prev], [data-afs-media-next]');
      if (mediaControl) {
        var mediaGallery = mediaControl.closest('[data-afs-media-gallery]');
        var mediaTrack = mediaGallery && mediaGallery.querySelector('[data-afs-media-track]');
        if (mediaTrack) {
          mediaTrack.scrollBy({ left: mediaControl.hasAttribute('data-afs-media-next') ? mediaTrack.clientWidth : -mediaTrack.clientWidth, behavior: 'smooth' });
          setTimeout(function () { updateAfsaanaGallery(mediaGallery); }, 360);
        }
        return;
      }

      var mediaDot = event.target.closest('[data-afs-media-dot]');
      if (mediaDot) {
        var dotGallery = mediaDot.closest('[data-afs-media-gallery]');
        var dotTrack = dotGallery && dotGallery.querySelector('[data-afs-media-track]');
        if (dotTrack) {
          dotTrack.scrollTo({ left: dotTrack.clientWidth * Number(mediaDot.dataset.afsMediaDot), behavior: 'smooth' });
          setTimeout(function () { updateAfsaanaGallery(dotGallery); }, 360);
        }
        return;
      }

      var control = event.target.closest('[data-afs-prev], [data-afs-next]');
      if (!control) return;

      var slider = control.closest('[data-afs-slider]');
      var track = slider && slider.querySelector('[data-afs-slider-track]');
      var card = track && track.querySelector('.afs__product-card');
      if (!track || !card) return;

      var gap = parseFloat(window.getComputedStyle(track).columnGap || 0);
      var distance = card.getBoundingClientRect().width + gap;
      track.scrollBy({ left: control.hasAttribute('data-afs-next') ? distance : -distance, behavior: 'smooth' });
    });

    document.addEventListener('scroll', function (event) {
      if (!event.target.matches || !event.target.matches('[data-afs-media-track]')) return;
      var gallery = event.target.closest('[data-afs-media-gallery]');
      window.requestAnimationFrame(function () { updateAfsaanaGallery(gallery); });
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.afs__quick-add-form');
      if (!form) return;
      event.preventDefault();

      var section = form.closest('.afs');
      var button = form.querySelector('.afs__quick-add');
      var status = form.querySelector('.afs__quick-add-status');
      if (!form.reportValidity() || !button) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function (item) {
          status.textContent = section.dataset.addSuccess;
          button.textContent = section.dataset.addSuccess;
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item: item } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { button.textContent = button.dataset.defaultLabel; }, 2200);
        })
        .catch(function () {
          status.textContent = section.dataset.addError;
        })
        .finally(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atarasva-contact-card"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atarasva-contact-card')) {
    customElements.define('atarasva-contact-card', class extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('[data-contact-save]');
        const source = this.querySelector('[data-contact-data]');
        if (!link || !source) return;
        if (this.contactUrl) URL.revokeObjectURL(this.contactUrl);
        const data = source.dataset;
        const escapeValue = value => String(value || '').replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
        const lines = ['BEGIN:VCARD', 'VERSION:3.0', 'FN:' + escapeValue(data.name), 'N:;' + escapeValue(data.name) + ';;;', 'ORG:' + escapeValue(data.name)];
        if (data.phone) lines.push('TEL;TYPE=WORK,VOICE:' + escapeValue(data.phone));
        if (data.email) lines.push('EMAIL;TYPE=WORK:' + escapeValue(data.email));
        if (data.instagram) lines.push('URL:' + escapeValue(data.instagram));
        if (data.facebook) lines.push('URL:' + escapeValue(data.facebook));
        lines.push('END:VCARD');
        this.contactUrl = URL.createObjectURL(new Blob([lines.join('\r\n') + '\r\n'], { type: 'text/vcard;charset=utf-8' }));
        link.href = this.contactUrl;
        link.download = (data.name || 'Contact').replace(/[^a-z0-9_-]/gi, '_') + '.vcf';
        link.hidden = false;
      }
      disconnectedCallback() {
        if (this.contactUrl) URL.revokeObjectURL(this.contactUrl);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
